import { defineProfile } from "./define.js";

export const REAL_ESTATE_PROFILE = defineProfile("real_estate", {
  labels: ["contacts", "bookings", "staff", "pipeline"],
  home: ["new_leads", "viewings_this_week", "deals_open", "unread_chats"],
  kpis: ["leads", "viewings", "conversations", "response_time", "deals_open", "ai_handoffs"],
  panel: ["interests", "viewings", "deal"],
  quickActions: ["book_viewing", "send_similar_properties"],
  contactFields: [
    { key: "area", kind: "text", label: { ar: "المنطقة", en: "Area" } },
    { key: "budget", kind: "number", label: { ar: "الميزانية", en: "Budget" } },
    { key: "property_kind", kind: "select", label: { ar: "نوع العقار", en: "Property type" } },
  ],
  aiTools: ["search_kb", "book_slot", "save_lead", "escalate"],
  cloudStarterMenu: "real_estate_menu",
  starterPack: "real-estate",
});
